import { containers, elements, feedback } from '@ecosystem/newron-design-system';
import PerformanceAnalysisLineChart from '@data-visualization/performance-analysis-line-chart/PerformanceAnalysisLineChart';
import { ExportPerformanceBySegmentResp } from '@data-visualization/performance-analysis-line-chart/Types';
import { SaleType } from '@models/Products';
import { PERFORMANCE_ANALYSIS_MARKET_CARD_TITLE, PERFORMANCE_ANALYSIS_MARKET_TOOLTIP_MESSAGE } from '@pages/Utilities';
import { Periodicity } from '../time-period-selector/PeriodsTypes';

export interface PerformanceAnalysisMarketCardProps {
  data: ExportPerformanceBySegmentResp;
  selectedPeriodicity: Periodicity;
  currencySymbol: string;
  selectedLineChartSaleType: SaleType;
  noResultHandler: () => void;
  noPeriodExistForMulticountry?: boolean;
}

const PerformanceAnalysisMarketCard: React.FC<PerformanceAnalysisMarketCardProps> = ({
  data,
  selectedPeriodicity,
  currencySymbol,
  selectedLineChartSaleType,
  noResultHandler,
  noPeriodExistForMulticountry,
}) => {
  const { Card } = containers;
  const { Tooltip } = feedback;

  return (
    <div>
      <Card>
        <Card.Title title={PERFORMANCE_ANALYSIS_MARKET_CARD_TITLE}>
          <div className="flex pl-4">
            <Tooltip testId="performance-analysis-market-card-tooltip" placement="top" theme="light">
              <Tooltip.Content>
                <p>{PERFORMANCE_ANALYSIS_MARKET_TOOLTIP_MESSAGE}</p>
              </Tooltip.Content>
              <div>
                <elements.Icon color="brand">
                  <elements.Icon.icons.HelpOutline />
                </elements.Icon>
              </div>
            </Tooltip>
          </div>
        </Card.Title>
        <PerformanceAnalysisLineChart
          data={data}
          selectedPeriodicity={selectedPeriodicity}
          currencySymbol={currencySymbol}
          selectedLineChartSaleType={selectedLineChartSaleType}
          isMarket={true}
          noResultHandler={noResultHandler}
          noPeriodExistForMulticountry={noPeriodExistForMulticountry}
        />
      </Card>
    </div>
  );
};

export default PerformanceAnalysisMarketCard;
